import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

export default class LogoSlider {
    constructor() {
        if($('.js-logo-slider').length) {
            const $logoSlider = $('.js-logo-slider');

            $logoSlider.each(function() {
                const $slider = $(this)[0];

                const logoSlider = new Swiper($slider, {
                    autoplay: {
                        delay: 5000
                    },
                    loop: true,
                    modules: [
                        Autoplay,
                        Pagination
                    ],
                    pagination: {
                        clickable: true,
                        el: '.swiper-pagination',
                        enabled: false
                    },
                    slidesPerGroup: 2,
                    slidesPerView: 2,
                    spaceBetween: 40,
                    breakpoints: {
                        768: {
                            pagination: {
                                enabled: true
                            },
                            slidesPerGroup: 3,
                            slidesPerView: 3,
                            spaceBetween: 80
                        },
                        1024: {
                            pagination: {
                                enabled: true
                            },
                            slidesPerGroup: 4,
                            slidesPerView: 4,
                            spaceBetween: 80
                        }
                    }
                });
            });
        };
    };
};
